import axiosInstance from '../helpers/axiosInstance'

// The platform bounds the WP15 POST at 15s and rack-timeout aborts the whole
// request at 25s, so past this the network is at fault, not Natura.
const RESEND_TIMEOUT_MS = 45_000

// axiosInstance sets no default timeout, so without this a dropped connection
// leaves the screen in its in-flight state with no way out but a reload.
const PREVIEW_TIMEOUT_MS = 30_000

const BASE = `${process.env.REACT_APP_PLATFORM_URL}/api/v1/natura-operations/replenishment-confirmations`

export const previewConfirmationResend = async payload => {
  const { data } = await axiosInstance.post(`${BASE}/preview`, payload, { timeout: PREVIEW_TIMEOUT_MS })
  return data
}

export const resendConfirmation = async payload => {
  const { data } = await axiosInstance.post(`${BASE}/resend`, payload, { timeout: RESEND_TIMEOUT_MS })
  return data
}
